/**
 * The plain notes under a Similar-tab card (client round 2 October 2026).
 *
 * The tab's two blocks say what they say in numbers: two bars, a similarity, a gap and a
 * tag. A reader who works with watersheds reads that in a second; a reader who does not
 * reads it as a chart with a caption. The note is the second reader's version of the same
 * card — what is happening, and what to look out for — in sentences with no statistics
 * word in them.
 *
 * It is a **two-column list**, not two paragraphs: the labels repeat on every card, so
 * they line up down the block and the eye can skip them, and the sentences all start at
 * the same x. A `<dl>` is what that is — `<div>` rows inside it are the HTML way to pair
 * a term with its description and still have one grid cell each.
 */
export interface Uc2NoteRow {
  /** The left column: "What is happening" / "What to look out for". */
  label: string;
  /** The sentences for that label — one per rendered line. */
  lines: string[];
}

export interface Uc2NotesProps {
  rows: Uc2NoteRow[];
  testId: string;
}

export function Uc2Notes({ rows, testId }: Uc2NotesProps) {
  return (
    <dl className="uc2-note" data-testid={testId}>
      {rows.map((row) => (
        <div className="uc2-note-row" key={row.label}>
          <dt>{row.label}</dt>
          <dd>
            {row.lines.map((line) => (
              <span key={line}>{line}</span>
            ))}
          </dd>
        </div>
      ))}
    </dl>
  );
}

export default Uc2Notes;
